import { __read } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import { CartContext } from '../../context/CartContext.esm.js';
import { IconPartnership, CircleVariant, ColorVariant, SizeVariant } from '@invitae/iconograph-react';
import { NvButton } from '@invitae/ids-react';
import { PartnershipLabels } from './PartnershipLabels.esm.js';
import { PartnershipSearch } from './PartnershipSearch.esm.js';
import styles from './PartnershipCode.module.esm.js';

var PartnershipCode = function (_a) {
    var isInMiniCart = _a.isInMiniCart, partnershipCode = _a.partnershipCode;
    var _b = React.useContext(CartContext), addPartnerships = _b.addPartnerships, meta = _b.meta, removePartnerships = _b.removePartnerships;
    var partnership = meta === null || meta === void 0 ? void 0 : meta.partnership;
    var isAvailable = partnership === null || partnership === void 0 ? void 0 : partnership.isAvailableForPartnership;
    var partnerships = partnership === null || partnership === void 0 ? void 0 : partnership.selectedPartnerships;
    var hasPartnerships = !!(isAvailable && (partnerships === null || partnerships === void 0 ? void 0 : partnerships.length));
    var _c = __read(React.useState(hasPartnerships), 2), showSearch = _c[0], setShowSearch = _c[1];
    var _d = __read(React.useState(null), 2), selectedCode = _d[0], setSelectedCode = _d[1];
    React.useEffect(function () {
        setShowSearch(hasPartnerships);
    }, [hasPartnerships]);
    var selectCode = React.useCallback(function (value) {
        if (value !== undefined) {
            setSelectedCode(value || null);
        }
    }, [setSelectedCode]);
    var onClickHandler = React.useCallback(function () { return setShowSearch(true); }, []);
    var onSubmitCode = React.useCallback(function () {
        if (selectedCode === null || selectedCode === void 0 ? void 0 : selectedCode.value) {
            addPartnerships(selectedCode.value);
        }
    }, [selectedCode, addPartnerships]);
    var onRemoveCode = React.useCallback(function (value) {
        if (value) {
            removePartnerships(value);
        }
    }, [removePartnerships]);
    if (isInMiniCart) {
        if (!(partnershipCode || hasPartnerships))
            return null;
        return (React.createElement("div", { className: classNames(styles.partnership, styles.inMiniCart) },
            React.createElement(PartnershipLabels, { isInMiniCart: true, partnerships: partnershipCode ? [{ label: partnershipCode, value: partnershipCode }] : partnerships })));
    }
    return (React.createElement("div", { className: styles.partnership },
        React.createElement("div", { className: styles.iconWrapper },
            React.createElement(IconPartnership, { circle: CircleVariant.yes, color: ColorVariant.none, currentColor: true, size: SizeVariant.small })),
        showSearch ? (React.createElement(React.Fragment, null,
            hasPartnerships && React.createElement(PartnershipLabels, { onRemoveCode: onRemoveCode, partnerships: partnerships }),
            !hasPartnerships && (React.createElement(React.Fragment, null,
                React.createElement(PartnershipSearch, { onChange: selectCode }),
                React.createElement(NvButton, { dataTestId: "apply-code-button", disabled: !selectedCode, onClick: onSubmitCode, size: "medium" }, "Apply"))))) : (React.createElement("button", { className: styles.partnershipBtn, "data-testid": "enable-partnership-search-button", onClick: onClickHandler }, "Do you have a partnership code?"))));
};

export { PartnershipCode };
//# sourceMappingURL=PartnershipCode.esm.js.map
